import Marquee from './Marquee';
import ClientLogoMarquee from './ClientLogoMarquee';
import DynamicClientLogoMarquee from './DynamicClientLogoMarquee';

export default Marquee;

export { ClientLogoMarquee, DynamicClientLogoMarquee };
